/* Postal code → earliest delivery slot. Singapore time throughout.
   Promise (4 Sep 2026): delivered within 3–5 working days. The answer names the first
   date `leadDays` working days out; the Sprint 3 slot picker offers nothing sooner than that or
   later than `maxDays`. Working days skip Sunday and the gazetted public holidays in
   window.dnConfig.holidays (theme setting; MOM list, edited by ops each year).
   The value persists in localStorage (dn.postal). Writing it to the customer metafield needs
   an app proxy and lands with the account surfaces in Sprint 4. */
(function () {
  var cfg = window.dnConfig || {};
  var LEAD = Number(cfg.leadDays) || 3;
  var KEY = 'dn.postal';
  var SG = 'Asia/Singapore';

  // MOM public holidays 2026-2027, the same list as SG_HOLIDAYS in the Brain's slots.ts (qa/unit/holidays-agree.test.mjs).
  var DEFAULT_HOLIDAYS = ['2026-01-01', '2026-02-17', '2026-02-18', '2026-03-21', '2026-04-03', '2026-05-01', '2026-05-27', '2026-06-01', '2026-08-10', '2026-11-09', '2026-12-25',
    '2027-01-01', '2027-02-06', '2027-02-08', '2027-03-10', '2027-03-26', '2027-05-01', '2027-05-17', '2027-05-20', '2027-08-09', '2027-10-28', '2027-12-25'];
  var holidays = {};
  (cfg.holidays && cfg.holidays.length && cfg.holidays.join('').trim() ? cfg.holidays : DEFAULT_HOLIDAYS).forEach(function (d) {
    d = String(d).trim(); if (d) holidays[d] = true;
  });

  // Postal sectors (first two digits) → district name. Standard URA table.
  var SECTORS = {
    '01': 'Raffles Place', '02': 'Raffles Place', '03': 'Marina', '04': 'Marina', '05': 'Cecil', '06': 'Marina',
    '07': 'Anson', '08': 'Tanjong Pagar', '09': 'Sentosa', '10': 'Harbourfront', '11': 'Pasir Panjang', '12': 'Clementi',
    '13': 'Dover', '14': 'Queenstown', '15': 'Redhill', '16': 'Tiong Bahru', '17': 'Beach Road', '18': 'Middle Road',
    '19': 'Golden Mile', '20': 'Little India', '21': 'Farrer Park', '22': 'Orchard', '23': 'River Valley', '24': 'Tanglin',
    '25': 'Tanglin', '26': 'Bukit Timah', '27': 'Holland', '28': 'Watten Estate', '29': 'Thomson', '30': 'Novena',
    '31': 'Toa Payoh', '32': 'Balestier', '33': 'Whampoa', '34': 'Macpherson', '35': 'Potong Pasir', '36': 'Braddell',
    '37': 'Braddell', '38': 'Geylang', '39': 'Paya Lebar', '40': 'Eunos', '41': 'Geylang', '42': 'Katong', '43': 'Joo Chiat',
    '44': 'Marine Parade', '45': 'Siglap', '46': 'Bedok', '47': 'Bedok', '48': 'Upper East Coast', '49': 'Loyang',
    '50': 'Changi', '51': 'Pasir Ris', '52': 'Tampines', '53': 'Hougang', '54': 'Sengkang', '55': 'Serangoon',
    '56': 'Ang Mo Kio', '57': 'Bishan', '58': 'Upper Bukit Timah', '59': 'Clementi Park', '60': 'Jurong', '61': 'Jurong',
    '62': 'Jurong Island', '63': 'Tuas', '64': 'Jurong West', '65': 'Bukit Batok', '66': 'Hillview', '67': 'Bukit Panjang', /* 67xxxx is Bukit Panjang's estate (Fajar, Segar, Petir); the whole table was re-checked on 7 Sep 2026 after 670418 and 758270 named the wrong towns */
    '68': 'Choa Chu Kang', '69': 'Lim Chu Kang', '70': 'Tengah', '71': 'Tengah', '72': 'Kranji', '73': 'Woodlands',
    '75': 'Sembawang', '76': 'Yishun', '77': 'Upper Thomson', '78': 'Springleaf', '79': 'Seletar', '80': 'Seletar',
    '81': 'Changi Airport', '82': 'Punggol'
  };

  function sgToday() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: SG, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    return new Date(Number(o.year), Number(o.month) - 1, Number(o.day));
  }
  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  /* Monday to Saturday, minus public holidays (11 Sep 2026: "exclude sunday and public
     holidays"). Saturday used to be excluded with Sunday, which is the office week and not the
     van's. This MUST stay identical to isWorkingDay in brain/packages/domain/src/slots.ts: the
     header prints its earliest-slot estimate from this file and the picker gets its days from that
     one, and a shopper who is told Friday here and offered Monday there has been lied to by one of
     them. The domain test names this file for that reason. */
  function isWorkingDay(d) { var w = d.getDay(); return w !== 0 && !holidays[iso(d)]; }
  function addWorkingDays(from, n) {
    var d = new Date(from), count = 0;
    while (count < n) { d.setDate(d.getDate() + 1); if (isWorkingDay(d)) count++; }
    return d;
  }
  // Month from a table: en-SG prints "Sept", and the slot picker's chips and the Brain's labels say "Sep" (8 Sep 2026).
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtDay(d) { return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }

  function zone(pc) {
    var s = pc.slice(0, 2);
    var name = SECTORS[s];
    if (s === '09') return { name: name, note: 'Sentosa: our driver calls you before entering the island.', window: '9am–1pm' };
    if (s === '62' || s === '63') return { name: name, note: 'Tuas and Jurong Island: 1–5pm slot only.', window: '1–5pm' };
    if (!name) return { name: null, note: 'We do not recognise that postal code. Check the six digits.', window: null };
    return { name: name, note: '', window: '9am–1pm' };
  }

  function computeAnswer(pc) {
    var z = zone(pc);
    if (!z.window) return { ok: false, note: z.note };
    var day = addWorkingDays(sgToday(), LEAD);
    return { ok: true, day: day, label: fmtDay(day), window: z.window, area: z.name, note: z.note, postal: pc };
  }

  function typeIn(el, text) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { el.textContent = text; return; }
    // The one orchestrated moment: the answer types in over --dn-motion-ms (400ms).
    // aria-busy while it types: the line is a live region, and a screen reader otherwise reads out every
    // partial string (Sprint 8 design pass). It hears the whole answer once, when busy clears.
    el.textContent = '';
    el.setAttribute('aria-busy', 'true');
    var steps = text.length, i = 0, t0 = performance.now(), dur = 400;
    (function frame(t) {
      var k = Math.min(steps, Math.round((t - t0) / dur * steps));
      if (k !== i) { i = k; el.textContent = text.slice(0, i); }
      if (i < steps) requestAnimationFrame(frame); else el.removeAttribute('aria-busy');
    })(t0);
  }

  function render(a, animate) {
    document.querySelectorAll('[data-dn-answer]').forEach(function (el) {
      if (!a.ok) { el.setAttribute('data-state', 'error'); el.textContent = 'Check the postal code'; return; }
      el.setAttribute('data-state', 'resolved');
      var text = 'Earliest slot: ' + a.label + ', ' + a.window;
      if (animate && !el.hasAttribute('data-dn-answer-static')) typeIn(el, text); else el.textContent = text;
    });
    document.querySelectorAll('[data-dn-note]').forEach(function (el) {
      el.textContent = a.ok ? ('Delivered to ' + (a.area ? a.area + ' (' + a.postal + ')' : a.postal) + (a.note ? '. ' + a.note : '')) : a.note;
    });
    /* The collapsed summary names the AREA once a code resolves, and asks for one before that
       (10 Sep 2026: "If without entering: Enter Delivery Postal Code. If after entering:
       Show Delivery Area", then, when that shipped as the literal words: "i mean showing the actual
       area, for example, 588177 points to Upper Bukit Timah Road"). So the resolved state is the
       place name, not a label describing one.

       What it no longer carries is the earliest-slot tail. "Deliver to Upper Bukit Timah, earliest
       slot Mon, 14 Sep, 9am-1pm" ran to roughly 670px, and this line is what sizes the header's
       third grid column, so it was squeezing the search box into ~370px of a column with room for
       far more. Dropping the tail costs nothing: the slot, the window and the postal code are all
       still in the panel this summary opens, written by [data-dn-answer] and [data-dn-note]
       immediately above.

       a.area || a.postal, so an unrecognised sector still says something true rather than nothing.

       Built from DOM nodes rather than an HTML string: the <u> is wanted (it is what
       `.dn-postal-state > summary u` underlines) but the area name arrives from the postal lookup
       rather than from us, and setting it as text keeps it out of an HTML sink. */
    document.querySelectorAll('[data-dn-postal-summary]').forEach(function (el) {
      el.textContent = '';
      if (!a.ok) { el.textContent = 'Enter Delivery Postal Code'; return; }
      var place = document.createElement('u');
      place.textContent = a.area || a.postal;
      el.appendChild(document.createTextNode('Deliver to '));
      el.appendChild(place);
    });
    document.querySelectorAll('[data-dn-postal-form] input[name="postal"]').forEach(function (i) { if (a.ok) i.value = a.postal; });
  }

  function submit(form, animate) {
    var input = form.querySelector('input[name="postal"]');
    var v = (input.value || '').replace(/\D/g, '');
    if (v.length !== 6) {
      input.setCustomValidity('Six digits, like 730123');
      input.reportValidity();
      return;
    }
    input.setCustomValidity('');
    var a = computeAnswer(v);
    if (a.ok) {
      try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
    }
    render(a, animate);
    document.dispatchEvent(new CustomEvent('dn:postal', { detail: a }));
  }

  function init() {
    document.querySelectorAll('[data-dn-postal-form]').forEach(function (form) {
      if (form.dataset.dnBound) return;
      form.dataset.dnBound = '1';
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(form, true); });
      form.querySelector('input[name="postal"]').addEventListener('input', function () { this.setCustomValidity(''); });
    });
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) { /* private mode */ }
    if (saved && /^\d{6}$/.test(saved)) render(computeAnswer(saved), false);
    else resetEmpty();
  }
  function resetEmpty() {
    document.querySelectorAll('[data-dn-answer]').forEach(function (el) {
      el.setAttribute('data-state', 'empty');
      el.textContent = el.getAttribute('data-dn-empty') || 'Enter your postal code for your earliest slot';
    });
    document.querySelectorAll('[data-dn-note]').forEach(function (el) { el.textContent = ''; });
  }

  window.dnPostal = { compute: computeAnswer, addWorkingDays: addWorkingDays, isWorkingDay: isWorkingDay };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
